import { ExternalDropzone } from "./external-dropzone";
import { FilesHeader } from "./files-header";
import { FilesList } from "./files-list";

export const InsuredFiles = () => (
  <div className="@container/files flex flex-auto overflow-hidden">
    <ExternalDropzone className="flex flex-auto flex-col overflow-y-auto @3xl/files:overflow-hidden">
      <FilesHeader />
      <div className="flex-auto @3xl/files:min-h-0">
        <FilesList />
      </div>
    </ExternalDropzone>
  </div>
);
